export default "__VITE_ASSET__1Et_Kz11__"